import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
import { Swiper, SwiperSlide } from "swiper/react"

// import { useCartSettings } from "../../../hooks/useCart"
import ModalsDrawer from "../../Modals/ModalsDrawer"
import { StyledButton } from "../../Styled/Button"
import { Icon } from "../../Icon/Icon"
import { CartList } from "../List/CartList"
import { CartDonationItem } from "../CartDonationItem/CartDonationItem"
import { CartCheckout } from "../Checkout/CartCheckout"
import { withCartMini } from "./withCartMini"
import CartUpsells from "../CartUpsells"

// const Wrapper = tw.div`h-full`
const Wrapper = styled.div`
  position: relative;
  height: 100%;
`

const HeaderSection = tw.div`fixed top-0 w-full z-30 flex flex-row items-center bg-light h-6 md:h-10 px-2-4`
const Overlay = tw.div`absolute top-0 bottom-0 w-full h-full z-0 bg-light`
const Title = tw.div`uppercase` // stylesmall
const IconButton = tw(StyledButton)`mr-2 rounded-full focus:text-light`
const StyledIcon = styled(Icon)`
  ${tw`mx-auto`}
`
const Inner = tw.div`pt-8 flex flex-col justify-between h-full px-2-4`
const CartListSection = tw.div`flex flex-col z-20 justify-start`

const CheckoutSection = styled.div<ContainerInnerProps>`
  ${tw`absolute z-20 w-full bottom-0 bg-light pt-0 pb-3-2`}
  ${({ count }) => (count < 1 ? tw`` : tw`shadow-card bg-light`)}
  background: #fbfaf2;
`
const TrustSliderWrapper = styled.div`
  /* max-width: 238px; */
  margin: 0 auto;
`
const SlideImg = styled.img`
  max-width: 38px;
  margin-bottom: 10px;
`
const Slide = tw.div`flex flex-col items-center mb-2`
const SlideText = tw.h6``
export const CartMini = withCartMini(
  ({
    activeCart,
    handleCartActive,
    winH,
    count,
    cartItemHeight,
    overflowY,
    donationEnabled,
    donationTitle,
    donationContent,
    donationImage,
    isTrust,
    trustSlides,
    additionalPageTitle,
    additionalCheckoutButton,
    additionalGeneralFeatureContentsOne,
    additionalGeneralFeatureContentsTwo,
    additionalFooterText,
  }): JSX.Element => {
    return (
      <ModalsDrawer active={activeCart} setActive={handleCartActive} right noClose class type={"cart"}>
        <Wrapper style={{ height: winH + "px" }}>
          <HeaderSection>
            <IconButton className={`icon-button`} layout={`icon`} background={`light`} onClick={handleCartActive}>
              <StyledIcon name={`cross`} size={15} />
            </IconButton>
            <Title className="body_small_highlight">{`${additionalPageTitle} (${count})`}</Title>
          </HeaderSection>
          <Overlay />
          <Inner id="MiniCartInner">
            <CartListSection id="CartListSection" style={{ overflowY: overflowY, height: cartItemHeight, padding: "10px" }}>
              <CartList />
              {donationEnabled && count > 0 ? (
                <CartDonationItem donationTitle={donationTitle} donationContent={donationContent} donationImage={donationImage} />
              ) : null}
            </CartListSection>
          </Inner>
          {count > 0 || trustSlides.length > 0 ? (
            <CheckoutSection id="CheckoutSection" count={count}>
              {count > 0 && (
                <>
                  <CartUpsells />
                  <CartCheckout
                    additionalCheckoutButton={additionalCheckoutButton}
                    additionalGeneralFeatureContentsOne={additionalGeneralFeatureContentsOne}
                    additionalGeneralFeatureContentsTwo={additionalGeneralFeatureContentsTwo}
                    additionalFooterText={additionalFooterText}
                  />
                </>
              )}
              {isTrust && trustSlides.length > 0 ? (
                <TrustSliderWrapper className="TrustSliderWrapper isTrust">
                  <Swiper
                    pagination={{
                      clickable: true,
                    }}
                    observer={true}
                    observeParents={true}
                    spaceBetween={10}
                    slidesPerView={1}
                    loop={true}
                    lazy={true}
                    preloadImages={false}
                  >
                    {trustSlides.map((slide, index) => (
                      <SwiperSlide key={index}>
                        <Slide key={index}>
                          <SlideImg src={slide.slideImg.asset.url} />
                          <SlideText>{slide.slideText}</SlideText>
                        </Slide>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </TrustSliderWrapper>
              ) : null}
            </CheckoutSection>
          ) : null}
        </Wrapper>
      </ModalsDrawer>
    )
  }
)

type ContainerInnerProps = {
  active: boolean
}
